<template>
  <main class="d-flex flex-column justify-content-center align-items-center">
    <h1 class="text-center mb-4 text-mobile">
      Encontre os estabelecimentos mais
      <br />próximos de você
    </h1>
    <div class="form-container col-md-6 mb-5">
      <div>
        <div class="input-group input-group-lg">
          <input id="cep-municipio" type="text" name="cep-municipio" class="form-control"
            placeholder="Digite seu CEP, município ou nome do restaurante" v-model="filtro" @input="onInputChange" @keydown.enter="filter" @blur="filter" autocomplete="off" required />

          <div class="input-group-append">
            <button type="submit" class="input-group-text btn btn-primary text-white px-md-4" @click="filter">
              <small>BUSCAR</small>
            </button>
          </div>
        </div>
      </div>
      <ul v-if="municipiosFiltrados.length > 0 && this.filtro !== ''" class="autocomplete-list">
        <li v-for="(municipio, index) in municipiosFiltrados" class="autocomplete-item" :key="index"
          @click="selecionarMunicipio(municipio)">
          {{ municipio.nome }} -
          {{ municipio["regiao-imediata"]["regiao-intermediaria"]["UF"].sigla }}
        </li>
      </ul>
    </div>
    <div class="container">
      <div v-if="isLoading">
        <div class="loading-animation-div">
          <div class="loading-animation">
          </div>
        </div>
      </div>

      <div :class="{ results: response }" class="search-results col-12 text-center">
        <div v-if="response" class="row" v-match-heights="{ el: ['.card-title', '.card-text'] }">
          <div v-for="(restaurante, index) in restaurantesFiltrados" :key="index" class="col-md-3 px-0 px-md-3">
            <div class="card shadow" :class="{ ativo: restaurante.ativo }">
              <a class="text-dark d-flex d-md-block" :class="{ disabled: !restaurante.ativo }"
                :href="linkRestaurante(restaurante)" target="_blank">
                <img class="cover img-fluid" style="height: 120px;" :src="`https://cdn.prefirodelivery.com/${restaurante.slug}/assets/imagens/cover.jpg`" alt="Card image cap" onerror="this.src='/marketplace/assets/imagens/card-cover.jpg'" />
                <div class="avatar-box mx-auto">
                  <img v-if="restaurante.avatar" style="height: 100%; object-fit:cover;" :src="restaurante.avatar" class="avatar img-fluid" />
                </div>
                <div class="card-body p-2">
                  <h5 class="card-title">{{ restaurante.nome }}</h5>
                  <p class="card-text">
                    <small :key="index" v-for="(
                        especialidade, index
                      ) in restaurante.especialidade">{{ especialidade }}</small>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
        <!-- <p>
          <a class="anchor" href="#contactForm">Clique aqui</a> para indicar
          um restaurante.
        </p> -->
      </div>
      <div v-if="empty">
        <h3 class="text-center text-mobile" style="font-size:1.4rem">Ops... parece que ainda não atendemos na sua área :(</h3>
        <div class="text-center">
          <button class="btn btn-default btn-lg" @click="openModal">Indicar loja</button>
        </div>
        <!-- MODAL FORMULÁRIO -->
        <div class="modal fade" id="myModal" role="dialog">
          <notifications group="foo" />
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header flex-row-reverse" style="padding:35px 50px;">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h4>Indique uma loja</h4>
              </div>
              <div class="modal-body" style="padding:40px 50px;">
                <form @submit.prevent="submitEmailForm">
                  <div class="form-group">
                    <label for="nomeEstabelecimento">Nome do estabelecimento:</label>
                    <input type="text" class="form-control" id="nomeEstabelecimento" v-model="nomeEstabelecimento" required>
                  </div>
                  <div class="form-group">
                    <label for="email">E-mail:</label>
                    <input type="email" class="form-control" id="email" v-model="email" required>
                  </div>
                  <div class="form-group">
                    <label for="telefone">Telefone:</label>
                    <the-mask  type="text" class="form-control" id="telefone" v-model="telefone" required :mask="['(##) ####-####', '(##) #####-####']" />
                  </div>
                  <div class="form-group">
                    <label for="nomeResponsavel">Nome do responsável:</label>
                    <input type="text" class="form-control" id="nomeResponsavel" v-model="nomeResponsavel" required>
                  </div>
                  <button type="submit" class="btn btn-primary">Enviar E-mail</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container d-flex justify-content-center pt-4">
      <a class="btn btn-primary" v-if="!empty" :href="linkCadastroRestaurante" target="_blank">Cadastre seu restaurante</a>
    </div>
    <!-- <img src="assets/imagens/guy.png" alt class="prop" /> -->
  </main>
</template>

<script>
  import VueNotification from 'vue-notification';
  import Vue from 'vue'

  export default {
    name: "app",
    components: {
      VueNotification,
    },

    data() {
      return {
        linkCadastroRestaurante: "",
        nomeEstadoCompleto: "",
        filtro: "",
        mask: "",
        response: false,
        isLoading: false,
        restaurantes: [],
        restaurantesFiltrados: [],
        municipioId: null,
        municipios: [],
        municipiosFiltrados: [],
        latitude: null,
        longitude: null,

        nomeEstabelecimento: '',
        email: '',
        telefone: '',
        nomeResponsavel: '',
        showForm: true,
        messageForm: ''
      };
    },

    methods: {
      removerAcentos: function(texto) {
        let mapaAcentos = {
          a: /[\xE0-\xE6]/g,
          e: /[\xE8-\xEB]/g,
          i: /[\xEC-\xEF]/g,
          o: /[\xF2-\xF6]/g,
          u: /[\xF9-\xFC]/g,
          c: /\xE7/g,
          n: /\xF1/g
        };

        for (let letra in mapaAcentos) {
          let expressaoRegular = mapaAcentos[letra];
          texto = texto.replace(expressaoRegular, letra);
        }

        return texto
          .toLowerCase()
          .replace("-", "")
          .replace(/\s+/g, "-") // substitua espaços por hifens
          .replace(/(\d)-(\d)/g, "$1$2"); // remova hífens de sequências numéricas;
      },

      getMunicipios: function() {
        this.$http
          .get(`https://servicodados.ibge.gov.br/api/v1/localidades/municipios`)
          .then(data => {
            this.municipios = data.body;
          });
      },

      arrRestauranteFiltrado: function(nome) {
        for (let i = 0; i < this.restaurantes.length; i++) {
            if (nome && this.restaurantes[i].municipios.length > 0 && this.restaurantes[i].municipios.toString().match(nome)) {
              this.restaurantesFiltrados.push(this.restaurantes[i]);
            }
        }
      },

      formatarCEP(cep) {
        const cepRegex = /^(\d{5})(\d{3})?$/;
        const matches = cep.match(cepRegex);
        if (matches) {
          if (matches[2]) {
            return `${matches[1]}-${matches[2]}`;
          } else {
            return matches[1];
          }
        }
        return cep;
      },

      onInputChange(event) {
        let value = event.target.value;
        this.isLoading = false;

        if (/^\d+$/.test(value.charAt(0))) {
          value = value.replace(/[^\d-]/g, '');
          this.municipiosFiltrados = []
          if (/^\d+(-)?\d+$/.test(value)) {
            if (value.length <= 9) {
              this.filtro = this.formatarCEP(value);
            } else {
              value = value.slice(0, 9);
              this.filtro = this.formatarCEP(value);
            }
          }
        } else {
          value = value.replace(/[^a-zA-ZÀ-ú\s-]/g, '');
          event.target.value = value;

          this.municipiosFiltrados = this.municipios.filter(municipio => {
            const nomeMunicipio = this.normalizarParaBusca(municipio.nome);
            const termoBuscado = this.normalizarParaBusca(value);

            return nomeMunicipio.toString().match(termoBuscado);
          });

          this.filtro = value;
        }

      },

      selecionarMunicipio(municipio) {
        this.filtro =
          municipio.nome +
          " - " +
          municipio["regiao-imediata"]["regiao-intermediaria"]["UF"].sigla;
        this.municipiosFiltrados = [];
        this.municipioId = municipio.id;
        this.filter();
      },

      linkRestaurante: function(restaurante) {
        const params = new URLSearchParams(window.location.search);
        const utm_source = params.get("utm_source")
          ? params.get("utm_source")
          : "";
        const utm_medium = params.get("utm_medium")
          ? params.get("utm_medium")
          : "";
        const utm_campaign = params.get("utm_campaign")
          ? params.get("utm_campaign")
          : "";
        const utm_content = params.get("utm_content")
          ? params.get("utm_content")
          : "";

        return restaurante.ativo
          ? `${
              restaurante.slug
            }?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_content=${utm_content}`
          : "";
      },

      // FILTROS

      filter: function() {
        let filtroComAc = this.removerAcentos(this.filtro);

        if (/^\d{5}-?\d{3}$/.test(filtroComAc)) {
          this.filtrarPorCep();
          
          if(!this.empty){
            return;
          }
        }

        if (this.filtro.length > 2) {
          this.filtrarPorNomeDoEstabelecimento(this.filtro);
          
          if(!this.empty){
            return;
          }
        }

        if (this.filtro.length > 2) {
          this.filtrarPorMunicipio();
          
          return;
        }

        // Caso não seja nenhum dos tipos de filtro disponíveis, exibe uma mensagem de erro
        //alert("Por favor, digite um CEP, um nome de município ou ative a geolocalização.");
      },

      filtrarPorMunicipio: function() {
        //localStorage.setItem("lastFilter", this.filtro);
        this.isLoading = true;
        this.restaurantesFiltrados = [];
        this.municipiosFiltrados = [];
        let filtroMunicipio = this.municipioId ? this.municipioId : this.removerAcentos(this.filtro);
        let nomeIBGE = '';
        this.municipioId = null;

        this.$http.get(`https://servicodados.ibge.gov.br/api/v1/localidades/municipios/${filtroMunicipio}`).then((data)=>{
          if (Array.isArray(data.body)) {
            for (let index = 0; index < data.body.length; index++) {
              nomeIBGE = data.body[index].nome;
            }
          } else {
            nomeIBGE = data.body.nome
          }
          this.arrRestauranteFiltrado(nomeIBGE)
        })
        .finally(()=> {
          this.isLoading = false;
            if (this.restaurantesFiltrados.length == 0) {
              console.log('NÃO TEM RESTAURANTES FILTRADOS!');
            } else {
              this.response = true;
              console.log('RESTAURANTES FILTRADOS - ', this.restaurantesFiltrados);
            }
        });
      },

      filtrarPorCep: function() {
        //localStorage.setItem("lastFilter", this.filtro);
        this.isLoading = true;
        this.restaurantesFiltrados = [];
        let filtroCEP = this.filtro.replace("-", "");
        this.$http
        .get(`https://viacep.com.br/ws/${filtroCEP}/json/`)
        .then(data => {
              this.arrRestauranteFiltrado(data.body.localidade)
          })
          .finally(()=> {
            if (filtroCEP == '00000000') {
              console.log('IF FILTROCEP');
              for (let i = 0; i < this.restaurantes.length; i++) {
                  this.restaurantesFiltrados.push(this.restaurantes[i]);
              }
            }
            this.isLoading = false;
            if (this.restaurantesFiltrados.length == 0) {
              console.log('NÃO TEM RESTAURANTES FILTRADOS!');
            } else {
              this.response = true;
              console.log('RESTAURANTES FILTRADOS - ', this.restaurantesFiltrados);
            }
        });
      },

      // FILTRO POR NOME ESTABELECIMENTO
      filtrarPorNomeDoEstabelecimento: function(filtro) {
        this.restaurantesFiltrados = [];
        this.isLoading = true;
        let termo = this.normalizarParaBusca(filtro);

        for (const key of Object.keys(this.restaurantes)) {
          const restaurante = this.restaurantes[key];
          
          if(!restaurante.nome){
            continue;
          }

          const nomeRestaurante = this.normalizarParaBusca(restaurante.nome);
         
          if (nomeRestaurante.toString().match(termo)) {
            this.restaurantesFiltrados.push(restaurante);
          }
        }

        this.isLoading = false;

        this.response = true;
      },

      tirarAcentos(value){
        if(typeof value != 'string'){
          return '';
        }

        const stringNormalizada = value.normalize('NFD');

        return stringNormalizada.replace(/[\u0300-\u036f]/g, '');
      },

      normalizarEspacos(value){
        if(typeof value != 'string'){
          return '';
        }

        return value.replaceAll(/\s+/g, ' ');
      },

      normalizarParaBusca(value){
        if(typeof value != 'string'){
          return '';
        }

        let  termo = value.toLowerCase();
        termo = this.tirarAcentos(termo);
        termo = this.normalizarEspacos(termo);

        return termo;
      },

      filtrarPorLocalizacao() {
        this.restaurantesFiltrados = [];
        this.isLoading = true;

        fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${this.latitude}&lon=${this.longitude}`)
          .then(response => response.json())
          .then((data) => {
            const nomeCidade = data.address.city;
            const nomeEstado = data.address["ISO3166-2-lvl4"] ? data.address["ISO3166-2-lvl4"].split("-")[1] : undefined;

            if (!nomeCidade) {
              // Nome da cidade está indefinido
              console.log('NOME DA CIDADE INDEFINIDO!');
            } else {
              this.nomeEstadoCompleto = nomeCidade + " - " + nomeEstado;
              this.filtro = this.nomeEstadoCompleto;
              this.$root.$emit('atualizarTexto', this.nomeEstadoCompleto);

              this.arrRestauranteFiltrado(nomeCidade);

              if (this.restaurantesFiltrados.length == 0) {
                console.log('NÃO TEM RESTAURANTES FILTRADOS!');
              } else {
                this.response = true;
                console.log('RESTAURANTES FILTRADOS - ', this.restaurantesFiltrados);
              }
            }
          })
          .catch((error) => {
            console.log('OCORREU UM ERRO AO OBTER OS DADOS DE LOCALIZAÇÃO:', error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },

      // FORMULÁRIO

      submitEmailForm(){
        var formData = new FormData()
        formData.append('nomeEstabelecimento', this.nomeEstabelecimento);
        formData.append('email', this.email);
        formData.append('telefone', this.telefone);
        formData.append('nomeResponsavel', this.nomeResponsavel);

        try {
          fetch('lincedelivery/sugestao_estabelecimento', { method: 'POST', body: formData})
          Vue.notify({
            group: 'foo',
            title: 'Sugestão enviada!',
            text: 'Agradeçemos sua contribuição.',
            type: 'success'
          })
          this.showForm = false
          setTimeout(() => {
            this.closeModal();
            this.nomeEstabelecimento = ''
            this.email = ''
            this.telefone = ''
            this.nomeResponsavel = ''
          }, 1000);
        } catch (error) {
          Vue.notify({
            group: 'foo',
            title: 'Falha no envio!',
            text: 'Verifique se os dados estão corretos e tente novamente.',
            type: 'error'
          })
        }
      },
      openModal() {
        $("#myModal").modal();
      },
      closeModal() {
        $("#myModal").modal('hide');
      }
    },

    computed: {
      empty: function(){
        return this.restaurantesFiltrados.length == 0;
      }

    },

    updated(){
      this.linkCadastroRestaurante = link_cadastrar_restaurante || 'https://www.prefirodelivery.com.br/';
    },

    created() {
      this.getMunicipios();
      this.$http
      .get("/marketplace/buscarRestaurantes.php")
      .then(data => (this.restaurantes = data.body))
      .catch(error => console.error(error))
      .finally(() => {
        navigator.geolocation
          .getCurrentPosition(position => {
            const { latitude, longitude } = position.coords;
            this.latitude = latitude;
            this.longitude = longitude;
            this.filtrarPorLocalizacao();
          }, ()=>{
            if (!this.latitude && !this.longitude) {
              /*if (localStorage.getItem("lastFilter")) {
                this.filtro = localStorage.getItem("lastFilter");
                this.filter();
              }*/
            }
          })
      })
    }
  };
</script>

<style lang="css">
  .btn-default{
    background: #929d29;
    color: #fff;
    font-size: 16px;
  }
  .autocomplete-list {
    background: #ffffff;
    max-height: 25rem;
    box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0;
    overflow: auto;
  }

  .autocomplete-item {
    text-decoration: none;
    list-style: none;
    padding: 2px 0;
    margin: 3px 0;
    cursor: pointer;
    width: fit-content;
  }

  .loading-animation {
    position: relative;
    width: 30px;
    height: 30px;
    border-top-color: transparent!important;
    border-radius: 50%;
    animation: loading-animation-frame 1.6s linear infinite;
    top: 20px;
    left: 20px;
    box-sizing: content-box;
  }
  .loading-animation-div {
    display: flex;
    justify-content: center;
  }
  .loading-animation-frame {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }

  @keyframes loading-animation-frame {
    0% { transform: translate(-50%,-50%) rotate(0deg); }
    100% { transform: translate(-50%,-50%) rotate(360deg); }
  }

  @media screen and (max-width: 768px) {
    .text-mobile{
      font-size: 1.78rem;
    }
    main .card a img.cover {
      border-top-left-radius: 0.4rem;
      border-top-right-radius: 0;
      border-bottom-left-radius: 0.4rem;
      max-height: unset;
      max-width: 120px;
      min-height: 120px;
    }

    main .card a .avatar-box {
      transform: none;
      margin: 0;
      position: absolute;
      top: 15px;
      left: 15px;
      width: 90px;
      height: 90px;
    }

    .card-body {
      text-align: left;
      min-height: unset;
    }

    main .card {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue